import { useBilling } from "../../store/BillingContext";
import { useAuth } from "../../store/AuthContext";

const viewTitles: Record<string, { title: string; subtitle: string }> = {
  dashboard: {
    title: "Billing Overview",
    subtitle: "Real-time metrics, recent invoices, and business actions",
  },
  invoices: {
    title: "Tax Invoices",
    subtitle: "Manage, track, send, and download customer invoices",
  },
  quotations: {
    title: "Quotations & Estimates",
    subtitle: "Issue proposals and convert accepted quotes directly to invoices",
  },
  clients: {
    title: "Client Directory",
    subtitle: "Manage customer profiles, billing addresses, and tax numbers",
  },
  services: {
    title: "Services & Rate Card",
    subtitle: "Configure recurring retainers, fixed projects, and SAC/HSN codes",
  },
  expenses: {
    title: "Business Expenses",
    subtitle: "Track operating costs, software subscriptions, and vendor payouts",
  },
  accounting: {
    title: "Financial Accounting & P&L",
    subtitle: "Profit & loss statement, balance sheet snapshot, cash flow, and GST ledger",
  },
  settings: {
    title: "Agency Settings",
    subtitle: "Company profile, banking instructions, and GST configuration",
  },
};

export const Header: React.FC = () => {
  const { view, openNewDocument, setActiveForm } = useBilling();
  const { user, logout } = useAuth();
  const meta = viewTitles[view] || { title: "Dashboard", subtitle: "Billing Hub" };

  return (
    <header>
      <div>
        <h1>{meta.title}</h1>
        <p>{meta.subtitle}</p>
      </div>

      <div className="actions">
        {view === "clients" && (
          <button
            className="primary"
            onClick={() => setActiveForm({ kind: "client", value: { id: "", name: "", company: "", email: "", phone: "", address: "", gstin: "", industry: "" } })}
          >
            <i className="fa-solid fa-user-plus" /> Add Client
          </button>
        )}
        {view === "services" && (
          <button
            className="primary"
            onClick={() => setActiveForm({ kind: "service", value: { id: "", name: "", category: "Website Development", rate: 0, billing: "monthly", hsn: "998314", description: "" } })}
          >
            <i className="fa-solid fa-box-open" /> Add Service
          </button>
        )}
        {view === "expenses" && (
          <button
            className="primary"
            onClick={() => setActiveForm({ kind: "expense", value: { id: "", date: new Date().toISOString().slice(0, 10), category: "Software", vendor: "", amount: 0, paymentMethod: "Bank Transfer" } })}
          >
            <i className="fa-solid fa-plus" /> Add Expense
          </button>
        )}
        <button className="gold" onClick={() => openNewDocument("quote")}>
          <i className="fa-solid fa-file-lines" /> New Quotation
        </button>
        <button className="primary" onClick={() => openNewDocument("invoice")}>
          <i className="fa-solid fa-file-invoice-dollar" /> New Invoice
        </button>
        <button
          className="header-logout-btn"
          onClick={logout}
          title={`Sign Out (${user?.email || "Admin"})`}
        >
          <i className="fa-solid fa-arrow-right-from-bracket" />
          <span>Sign Out</span>
        </button>
      </div>
    </header>
  );
};
